import React, { useState } from "react";
import { Box, Container, Paper, Typography } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { usePermission } from "../../hooks/usePermission";
import OrganizationForm from "../../Components/Organizations/OrganizationForm";
import OrganizationTable from "../../Components/Organizations/OrganizationTable";
import ImportOrganizations from "../../Components/Organizations/ImportOrganizations";
import { CreateOrganizationsPermission } from "../../constants/permissions";
import OrganizationsReport from "../../Components/Organizations/OrganizationsReport";
import { ToastContainer } from "react-toastify";

const Organizations = () => {
  const { data: canCreateOrganization } = usePermission({
    permissionName: CreateOrganizationsPermission,
  });

  const [open, setOpen] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    organization_id: "",
    email: "",
    phone_number: "",
    contact_name: "",
    registration_number: "",
    APO_number: "",
    city_id: "",
    country_id: "",
  });

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setFormData({
      name: "",
      organization_id: "",
      email: "",
      phone_number: "",
      contact_name: "",
      registration_number: "",
      APO_number: "",
      city_id: "",
      country_id: "",
    });
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  return (
    <Container maxWidth="xl">
      <ToastContainer />
      <Box sx={{ py: 4 }}>
        <Box sx={{ display: "flex", justifyContent: "space-between", mb: 3 }}>
          <Typography variant="h4" component="h1">
            Organizations
          </Typography>
          {canCreateOrganization && (
            <div className="flex items-center space-x-2">
              <OrganizationsReport />
              <ImportOrganizations />
              <button
                className="bg-blueColor text-white rounded-md px-4 py-2 flex items-center gap-2"
                onClick={handleClickOpen}
              >
                <AddIcon />
                Add New Organization
              </button>
            </div>
          )}
        </Box>

        <Paper sx={{ width: "100%", overflow: "hidden" }}>
          <OrganizationTable />
        </Paper>

        <OrganizationForm
          open={open}
          onClose={handleClose}
          formData={formData}
          onInputChange={handleInputChange}
        />
      </Box>
    </Container>
  );
};

export default Organizations;
